import profile1 from '../assets/images/contacts/contact_1.jpg';
import profile2 from '../assets/images/contacts/contact_2.jpg';
import profile3 from '../assets/images/contacts/deepan.jpg';
import profile4 from '../assets/images/contacts/mufid.jpg';
import profile5 from '../assets/images/contacts/sandeep_patil.png';

const team = [
    {
        profile: profile1,
        name_en: 'Dr. Alok Mohan, IPS',
        name_ka: 'ಡಾ. ಅಲೋಕ್  ಮೋಹನ್, ಐಪಿಎಸ್',
        role_en: 'President, SPORTI',
        role_ka: 'ಅಧ್ಯಕ್ಷರು, SPORTI',
        desc_en: 'DG & IGP, Karnataka State Police',
        desc_ka: 'ಡಿ.ಜಿ ಮತ್ತು ಐ.ಜಿ.ಪಿ, ಕರ್ನಾಟಕ ರಾಜ್ಯ ಪೊಲೀಸ್',
    },
    {
        profile: profile2,
        name_en: 'Sri B Dayanand, IPS',
        name_ka: 'ಶ್ರೀ ಬಿ ದಯಾನಂದ, ಐಪಿಎಸ್',
        role_en: 'Vice President, SPORTI',
        role_ka: 'ಉಪಾಧ್ಯಕ್ಷರು, SPORTI',
        desc_en: 'Commissioner, Bengaluru City Police',
        desc_ka: 'ಆಯುಕ್ತರು, ಬೆಂಗಳೂರು ನಗರ ಪೊಲೀಸ್',
    },
    {
        profile: profile5,
        name_en: 'Sri Sandeep Patil, IPS',
        name_ka: 'ಶ್ರೀ ಸಂದೀಪ್ ಪಾಟೀಲ್, ಐಪಿಎಸ್',
        role_en: 'Supervisory officer, SPORTI-2',
        role_ka: 'ಪರಿವೀಕ್ಷಣಾಧಿಕಾರಿಗಳು, SPORTI-2',
        desc_en: 'IGP, KSRP',
        desc_ka: 'ಐ.ಜಿ.ಪಿ, ಕೆ.ಎಸ್.ಆರ್.ಪಿ',
    },
    {
        profile: './images/aboutus/raman.jpg',
        name_en: 'Sri Raman Gupta, IPS',
        name_ka: 'ಶ್ರೀ ರಾಮನ್ ಗುಪ್ತಾ, ಐಪಿಎಸ್',
        role_en: 'Supervisory Officer, SPORTI-1',
        role_ka: 'ಪರಿವೀಕ್ಷಣಾಧಿಕಾರಿಗಳು, SPORTI-1',
        desc_en: 'Addl. CP (East), Bengaluru City',
        desc_ka: 'ಹೆಚ್ಚುವರಿ ಪೊಲೀಸ್ ಆಯುಕ್ತರು (ಪೂರ್ವ), ಬೆಂಗಳೂರು ನಗರ',
    },
    {
        profile: profile3,
        name_en: 'Sri Deepan M.N, IPS',
        name_ka: 'ಶ್ರೀ ದೀಪನ್‌ ಎಂ.ಎನ್‌,  ಐಪಿಎಸ್‌.',
        role_en: 'Secretary, SPORTI',
        role_ka: 'ಕಾರ್ಯದರ್ಶಿಗಳು, SPORTI',
        desc_en: 'I/C DIGP & Commandant 1st Battalion KSRP',
        desc_ka: 'ಐ/ಸಿ ಡಿ.ಐ.ಜಿ.ಪಿ & ಕಮಾಂಡೆಂಟ್‌ 1 ನೇ ಪಡೆ ಕೆ.ಎಸ್‌.ಆರ್‌.ಪಿ, ಬೆಂಗಳೂರು',
        contact: '+91 9480805801',
    },
    {
        profile: './images/aboutus/suresh.jpg',
        name_en: 'Sri Suresh M.G',
        name_ka: 'ಶ್ರೀ ಸುರೇಶ್ ಎಂ.ಜಿ',
        role_en: 'Mess officer SPORTI-2',
        role_ka: 'ಮೆಸ್ ಅಧಿಕಾರಿಗಳು SPORTI-2',
        desc_en: 'Asst. Commandant 1st Battalion KSRP',
        desc_ka: 'ಸಹಾಯಕ ಕಮಾಂಡೆಂಟ್‌ 1 ನೇ ಪಡೆ ಕೆ.ಎಸ್‌.ಆರ್‌.ಪಿ., ಬೆಂಗಳೂರು ',
        contact: '+91 9480805828',
    },
    {
        profile: profile4,
        name_en: 'Sri Mufid Khan',
        name_ka: 'ಶ್ರೀ ಮುಫಿದ್ ಖಾನ್',
        role_en: 'Mess Officer, SPORTI-1',
        role_ka: 'ಮೆಸ್ ಅಧಿಕಾರಿಗಳು, SPORTI-1',
        desc_en: 'Reserve Police Inspector, 1st Battalion KSRP.',
        desc_ka: 'ರಿಸರ್ವ್ ಪೊಲೀಸ್‌ ಇನ್ಸ್ಪೆಕ್ಟರ್,  1 ನೇ ಪಡೆ ಕೆ.ಎಸ್‌.ಆರ್‌.ಪಿ.',
        contact: '+91 9480805887',
    },
];

export default team;
